import { z } from 'zod';
const totpCode = z.string().regex(/^\d{6}$/, 'O código tem 6 dígitos');
const email = z.string().trim().toLowerCase().max(254).pipe(z.email('Informe um e-mail válido'));
/** Login do paciente: e-mail + código do app autenticador. Erro idêntico para e-mail desconhecido. */
export const portalLoginSchema = z.object({ email, code: totpCode });
/** Ativação pelo link do e-mail: o token vem do link e só vale uma vez. */
export const portalActivationSchema = z.object({ token: z.string().min(20).max(100) });
export const portalActivationResponseSchema = z.object({
    otpauthUri: z.string(),
    secret: z.string(), // para digitar à mão quando não der para ler o QR
    account: z.string(), // e-mail do paciente, como aparece no app
    issuer: z.string(), // nome da clínica, como aparece no app
});
export const portalActivationCompleteSchema = z.object({ token: z.string().min(20).max(100), code: totpCode });
/** Painel da equipe: enviar o link de acesso ao portal para o e-mail do paciente. */
export const portalInviteSchema = z.object({ email });
export const portalAccessSchema = z.object({
    status: z.enum(['none', 'invited', 'active']),
    email: z.string().nullable(),
    invitedAt: z.string().nullable(),
    inviteExpiresAt: z.string().nullable(),
    enrolledAt: z.string().nullable(),
});
export const CONSENT_PURPOSES_PUBLIC = [
    'privacy_notice', 'ai_processing_international', 'marketing', 'image_use_educational',
];
export const consentTermSchema = z.object({
    purpose: z.enum(CONSENT_PURPOSES_PUBLIC),
    version: z.string(),
    title: z.string(),
    summary: z.string(),
    /** Resumo em linguagem simples, em tópicos (docs/04 §6.5). */
    bullets: z.array(z.string()),
    /** true = ciência obrigatória para usar o portal; false = consentimento opcional (opt-in). */
    required: z.boolean(),
    legalBasis: z.string(),
});
export const consentStateSchema = z.object({
    purpose: z.enum(CONSENT_PURPOSES_PUBLIC),
    granted: z.boolean(),
    termVersion: z.string(),
    decidedAt: z.string(),
});
export const portalMeSchema = z.object({
    contact: z.object({ firstName: z.string(), maskedPhone: z.string().nullable() }),
    consents: z.array(consentStateSchema),
    /** Termos obrigatórios sem ciência na versão vigente → portal mostra a tela de privacidade. */
    pendingRequired: z.array(z.enum(CONSENT_PURPOSES_PUBLIC)),
});
export const consentDecisionsSchema = z.object({
    decisions: z.array(z.object({ purpose: z.enum(CONSENT_PURPOSES_PUBLIC), granted: z.boolean() })).min(1).max(10),
});
//# sourceMappingURL=portal.js.map